<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import 'echarts-liquidfill/src/liquidFill.js'; //在这里引入
export default {
  props:{
    chartName:{
      type:String,
    },
    chartData:{
      type:Array,
      default:()=>[]
    }
  },  
  data() {
    return {

    }
  },
  watch:{
    chartData:{
      handler(){
        this.getEchartData()
      },
      deep:true
    }
  },
  methods: {
    getEchartData() {
      // let data = [
      //   { value: 201,ratio:'37.22%', name: '矛...' },
      //   { value: 268,ratio:'49.63%', name: '城...' },
      //   { value: 71,ratio:'13.15%', name: '社会...' },
      // ]
      let data = this.chartData;
      const chart = this.$refs.chart
      if (chart) {
        const myChart = this.$echarts.init(chart)
        const option = {
          tooltip: {
            trigger: 'item'
          },
          color:['#DAC741','#298FF2','#5565FF','#29E4E8','#26EF5D'],
          legend: {
            color:['#3398DB','#2f4554'],
            orient: "vertical",
            pageIconInactiveColor:'#DAC741',
            pageIconColor:'#29E4E8',
            pageTextStyle:{
              color: "#D5E7E7",
            },
            pageButtonPosition:'end',
            padding:[0,0,5,0],
            type:'scroll',
            borderColor:'#657DE9',
            textStyle: {
                color: '#657DE9',
            },
            top: '53%',
            // right: "left",
            itemGap: 12,
            selectedMode: true,
            icon: "pin",
            textStyle: {
              color: "#D5E7E7",
              rich: {
                name: {
                  width: 80,
                  align: "left",
                },
                num: {
                  width: 50,
                  align: "center",
                },
                ratio: {
                  width: 45,
                  align: "right",
                },
              },
            },
            formatter(name) {
              for (let index = 0; index < data.length; index++) {
                const item = data[index];
                if(name == item.name){
                  return `{name|${item.name}}{num|${item.num}}{ratio|${item.ratio}%}`;
                }
              }
            },
          },
          series: [
            {
              type: 'pie',
              radius: ['30%', '50%'],
              center: ["50%",'23%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              data,
            }
          ]
        };
        myChart.setOption(option)
        window.addEventListener("resize", function () {
          myChart.resize()
        })
      }
      this.$on('hook:destroyed', () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      })
    },
  },
}
</script>